import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArkikWebComponentsModule } from '@core/modules';
import { ArkikSpinnerComponent } from './arkik-spinner.component';

/**
 * Programmatic component — used via ComponentPortal in ArkikLoaderService (providedIn: 'root').
 * Not used in any template. Must be imported at app root level so Ivy compiles it.
 */
@NgModule({
  declarations: [ArkikSpinnerComponent],
  imports: [CommonModule, ArkikWebComponentsModule],
  exports: [ArkikSpinnerComponent],
})
export class ArkikSpinnerComponentModule {}
